/* This file is in core bundle because it is used by Parent Guide */

const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const eases = require("eases");
const AnimatingCanvas = require("./AnimatingCanvas");
const MeasuredEl = require("./MeasuredEl");
const StudentLink = require("./StudentLink");
const ColorUtil = require("../util/ColorUtil");
const ImageCache = require("../util/ImageCache");
const {getBaseInstance} = require("../util/HOCUtil");
const CanvasMath = require("../canvasmath/CanvasMath");
const ContainerSize = require("../util/ContainerSize");

const styles = require("./styles/SetProgressButton.css");

const INFINITE_ATTEMPT_PERCENT = 0.2;
//The percent filled an infinite attempt problem fills up to if it has an incorrect trial
const INFINITE_ATTEMPT_ANIMATE_PERCENT = 0.6;
//The percent an infinite attempt problem animates to and from if it gets a new incorrect trial

module.exports = createReactClass({
	displayName: "SetProgressButton",

	propTypes: {
		resultID: PT.number,
		percentComplete: PT.number,
		problemNumber: PT.number,
		cellSize: PT.number.isRequired, //required to size the button correctly
		isComplete: PT.bool,
		isCorrect: PT.bool,
		isSkipped: PT.bool,
		isSaved: PT.bool,
		selectable: PT.bool,
		isActive: PT.bool,
		hasIntervened: PT.bool,
		isDisplayingQuitOption: PT.bool,
		linkTo: PT.string,
		infiniteAttempts: PT.bool,
		handleClick: PT.func,
		noColorResponse: PT.bool,
		noPointerEvents: PT.bool, //force no pointer events even if look is selectable (used in Intervention)
		demo: PT.bool,
		containerDims: PT.shape({
			width: PT.number.isRequired,
			height: PT.number.isRequired,
			left: PT.number.isRequired,
			top: PT.number.isRequired,
			windowWidth: PT.number.isRequired,
			windowHeight: PT.number.isRequired,
		}).isRequired,
		overrideStyleClass: PT.string,
	},

	getInitialState: function() {
		return {
			isHovering: false,
		};
	},

	getPercent: function(props) {
		if (props.infiniteAttempts) {
			return props.percentComplete ? INFINITE_ATTEMPT_PERCENT : 0;
		} else {
			return props.percentComplete;
		}
	},

	UNSAFE_componentWillMount: function() {
		this.percent = this.getPercent(this.props);
		this.correctPercent = 0;
		this.savedPercent = 0;
		this.isAnimating = false;
	},

	UNSAFE_componentWillReceiveProps: function(nextProps) {
		if (nextProps.resultID !== this.props.resultID) {
			this.canvasComp && this.canvasComp.stopAnimations();
			this.redraw = true;
			this.percent = this.getPercent(nextProps);
			this.correctPercent = 0;
			this.savedPercent = 0;
			//Refresh these values if the result id changes
			this.oldPercent = nextProps.percentComplete;
			this.oldComplete = nextProps.isComplete;
		} else if (
			nextProps.hasIntervened !== this.props.hasIntervened &&
			nextProps.selectable &&
			!nextProps.isComplete
		) {
			this.redraw = true;
		} else if (
			nextProps.isDisplayingQuitOption !== this.props.isDisplayingQuitOption &&
			!nextProps.isComplete
		) {
			this.redraw = true;
		} else if (
			(this.oldComplete && !nextProps.isComplete) ||
			(!this.oldSaved && nextProps.isSaved)
		) {
			this.redraw = true;
		} else {
			this.redraw = false;
		}
	},

	componentDidUpdate: function(prevProps, prevState) {
		this.checkForAnimation();
	},

	animatePercent: function(context, oldPercent, newPercent, t) {
		this.percent = oldPercent + eases.sineIn(t) * (newPercent - oldPercent);
		this.drawButton(context);
	},

	animatePercentPulse: function(context, startPercent, pulsePercent, t) {
		this.percent =
			pulsePercent +
			Math.abs(eases.sineInOut(t) - 0.5) * 2 * (startPercent - pulsePercent);
		this.drawButton(context);
	},

	animateCorrect: function(context, t) {
		this.correctPercent = eases.sineIn(t);
		this.drawButton(context);
	},

	animateSaved: function(context, t) {
		this.savedPercent = eases.sineIn(t);
		this.drawButton(context);
	},

	drawNumber: function(context, w) {
		const cS = ColorUtil.getCurrentScheme();
		const isInteractive =
			this.props.selectable &&
			!(this.props.isDisplayingQuitOption && !this.props.isComplete);
		let fontSize = ContainerSize.getFontSizes(this.props.containerDims)
			.problemProgressButton;
		if (this.props.isActive) {
			fontSize *= 1.5;
		}
		context.save();
		let color = this.props.isActive
			? cS.setProgressSelectedNumber
			: cS.setProgressNumber;
		if (this.state.isHovering && isInteractive && !this.props.isActive) {
			color = cS.setProgressSelectedNumber;
		}
		context.fillStyle = color;
		context.strokeStyle = color;
		CanvasMath.drawInRect(context, {
			batex: "" + this.props.problemNumber,
			rect: [0, 0, w, w],
			fontInfo: {
				family: ["Roboto Slab"],
				size: fontSize,
			},
			scaleDownOnly: true,
			centered: true,
		});
		context.restore();
	},

	drawButton: function(context) {
		const w = context.getWidth();
		const c = w / 2; // Coordinates of center
		const r = Math.floor(w / 2) - 1;
		const cS = ColorUtil.getCurrentScheme();
		context.bp().clearRect(-1, -1, w + 2, context.getHeight() + 2);
		const isInteractive =
			this.props.selectable &&
			!(this.props.isDisplayingQuitOption && !this.props.isComplete);
		const drawLock = !isInteractive;
		const drawInterventionExclamation =
			this.props.selectable &&
			!this.props.isComplete &&
			this.props.hasIntervened &&
			!this.props.demo;
		const complete = this.props.isComplete && this.oldComplete;
		const saved = !this.props.isSaved && !this.oldSaved;

		let circleColor = "#CCCCCC";
		if (!isInteractive) {
			circleColor = "#AAAAAA";
		} else if (complete) {
			circleColor = this.props.isCorrect ? cS.correctFill : cS.incorrectFill;
			if (this.props.isSkipped) {
				circleColor = cS.skippedFill;
			}
		} else if (this.props.isSaved) {
			circleColor = cS.iconYellow;
		} else if (this.props.isActive) {
			//Make selected plain circles slightly lighter
			circleColor = "#D6D6D6";
		}

		context
			.bp()
			.arc(c, c, r, 0, 2 * Math.PI)
			.fill(circleColor);
		if (!complete && this.percent > 0 && !drawInterventionExclamation) {
			context.save();
			context
				.bp()
				.rect(c - r - 1, c - r - 1, 2 * r * this.percent + 1, 2 * r + 2)
				.clip();
			context.bp().clearRect(-1, -1, w + 2, context.getHeight() + 2);
			context
				.bp()
				.arc(c, c, r, 0, 2 * Math.PI)
				.fill(this.props.isSkipped ? cS.skippedFill : cS.incorrectFill);
			context.restore();
		}
		if (!complete && this.correctPercent) {
			context
				.sv()
				.bp()
				.arc(c, c, r * this.correctPercent, 0, 2 * Math.PI)
				.fill(cS.correctFill)
				.rs();
		} else if (!saved && this.savedPercent) {
			context
				.sv()
				.bp()
				.arc(c, c, r * (1 - this.savedPercent), 0, 2 * Math.PI)
				.fill(cS.iconYellow)
				.rs();
		}

		//Drawing any images necessary over the progress circle
		if (drawLock) {
			context.drawImage(
				ImageCache.src(
					global.BASE_URL + "assets/images/icons/button-lock1.svg"
				),
				w * 0.1,
				w * 0.05,
				w * 0.9,
				w * 0.9
			);
		}
		if (drawInterventionExclamation) {
			context.drawImage(
				ImageCache.src(
					global.BASE_URL + "assets/images/icons/intervention-exclamation.svg"
				),
				0,
				0,
				w,
				w
			);
		}
		//Drawing the problem number
		if (!drawLock && !drawInterventionExclamation && this.props.problemNumber) {
			this.drawNumber(context, w);
		}
	},

	draw: function(context, options) {
		const fullRedraw = options.resized || options.loadedImages || this.redraw;
		if (fullRedraw) {
			this.oldPercent = this.props.percentComplete;
			this.oldComplete = this.props.isComplete;
			this.oldSaved = this.props.isSaved;
			this.percent = this.getPercent(this.props);
			this.correctPercent = 0;
			this.drawButton(context);
		}
	},

	checkForAnimation: function() {
		if (this.isAnimating) {
			return;
		}

		this.oldPercent = this.oldPercent || 0;
		this.oldComplete = this.oldComplete || false;
		this.oldSaved = this.oldSaved || false;

		let animationInfo = false;
		if (!this.oldComplete && this.props.isComplete) {
			//If the problem was just finished, animate:
			if (this.props.isCorrect) {
				//For correct answers, fill in a circle that grows.
				animationInfo = {
					draw: (innerContext, t) => this.animateCorrect(innerContext, t),
					duration: 400,
					redrawOnFinish: true,
				};
			} else {
				//For incorrect answers, just fill red across left to right.
				animationInfo = {
					draw: (innerContext, t) =>
						this.animatePercent(innerContext, this.oldPercent, 1, t),
					duration: 400,
				};
			}
		} else if (
			this.oldPercent < this.props.percentComplete &&
			!this.props.hasIntervened
		) {
			if (this.props.infiniteAttempts && this.oldPercent) {
				//If a problem has infinite attempts and this is not the first, pulse the percentage up and down
				animationInfo = {
					draw: (innerContext, t) =>
						this.animatePercentPulse(
							innerContext,
							INFINITE_ATTEMPT_PERCENT,
							INFINITE_ATTEMPT_ANIMATE_PERCENT,
							t
						),
					duration: 1200,
				};
			} else {
				//Otherwise, just fill in to the correct percentage
				animationInfo = {
					draw: (innerContext, t) =>
						this.animatePercent(
							innerContext,
							this.oldPercent,
							this.getPercent(this.props),
							t
						),
				};
			}
		} else if (this.oldSaved && !this.props.isSaved) {
			animationInfo = {
				draw: (innerContext, t) => this.animateSaved(innerContext, t),
				duration: 400,
			};
		}
		//TODO: What should happen if this.canvasComp is falsy?
		if (this.canvasComp && animationInfo) {
			//Set up the onFinish function for the animation
			const finalPercentComplete = this.props.percentComplete;
			const finalComplete = this.props.isComplete;
			const finalSaved = this.props.isSaved;
			const onFinish = () => {
				this.oldPercent = finalPercentComplete;
				this.oldComplete = finalComplete;
				this.oldSaved = finalSaved;
				this.isAnimating = false;
				if (animationInfo.redrawOnFinish) {
					const ctx = this.canvasComp.getContext();
					if (ctx) {
						this.drawButton(ctx);
					}
				}
				this.checkForAnimation();
			};
			//Then run the animation
			this.isAnimating = true;
			this.canvasComp.animateDraw({
				draw: animationInfo.draw,
				duration: animationInfo.duration || 300,
				onFinish,
			});
		}
	},

	onHover: function(isHovering) {
		this.redraw = true;
		this.setState({isHovering});
	},

	render: function() {
		const canvasEl = (
			<MeasuredEl className={styles.canvas}>
				<AnimatingCanvas
					noPointerEvents={true}
					draw={this.draw}
					ref={ref => (this.canvasComp = getBaseInstance(ref))}
				/>
			</MeasuredEl>
		);

		const isInteractive =
			this.props.selectable &&
			!(this.props.isDisplayingQuitOption && !this.props.isComplete);
		const buttonSize = Math.round(
			this.props.cellSize * (this.props.isActive ? 0.95 : 0.75)
		);
		const offset = Math.floor((this.props.cellSize - buttonSize) / 2);
		const buttonStyle = {
			pointerEvents:
				isInteractive && !this.props.noPointerEvents ? "auto" : "none",
			width: buttonSize,
			height: buttonSize,
			left: offset,
			top: offset,
		};

		const className = this.props.overrideStyleClass || styles.button;
		if (isInteractive) {
			return (
				<StudentLink
					to={this.props.linkTo}
					className={className}
					style={buttonStyle}
					clickSound={"navigate-problem"}
					onMouseEnter={() => this.onHover(true)}
					onMouseLeave={() => this.onHover(false)}
					useWonkyCursor={true}
					clickAction={this.props.handleClick}
				>
					<div className={styles.shadow} />
					{canvasEl}
				</StudentLink>
			);
		} else {
			return (
				<div
					onClick={this.props.handleClick}
					className={styles.button}
					style={buttonStyle}
				>
					<div className={styles.shadow} />
					{canvasEl}
				</div>
			);
		}
	},
});
